<script setup lang="ts"></script>

<template>
   <div
      class="flex h-screen w-full flex-col items-center justify-center gap-5 bg-brand-title p-3 text-center text-2xl text-brand-title md:text-4xl">
      <div class="w-20"><img src="/img/ipa-logo.png" alt="International Polo" /></div>
      <p>We are updating the polo E-learning experience.</p>
      <slot>
         <NuxtPage />
      </slot>
   </div>
</template>

<style scoped></style>
